export const replaceLocaleInUrl = (path, locale) => {
    const [, , ...rest] = path.split('/');
    return `/${[locale, ...rest].join('/')}`;
};
export function searchNormalize(s) {
    return s
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase();
}
